import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import ReactSVG from "react-svg";
import { escapeBaseTag } from "helpers";
import baseService from "services/BaseService";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { isEmpty, get } from "lodash";
import { Field, getFormValues, getFormSyncErrors, reduxForm } from "redux-form";
import { ModalWindow } from "ui-core-dashboard";
import DynamicForm from "../../pages/Ordering/common/DynamicForm";
import Loader from "components/Loader/index";

// TODO: moved to some shared place and rename it as SingleSelectWithSearch (similar to multiselect)
import { ReduxFormDecorator as TypeSelect } from "../../pages/Appeal/Form/components/AppealTypeSelect";
import ComboBox from "../../pages/Ordering/common/ComboBox";
import CompactCustomerSearch from "../../pages/Ordering/CompactCustomerSearch";
import cx from "classnames";

import "./styles.scss";

const TYPE_FORM = specType => `add-customer-${specType}`;
const DYNAMIC_FORM = specType => `add-customer-${specType}-dynamic`;

const mapStateToProps = state => {
    const specType = state.ui && state.ui.customerSpecModalType;
    return {
        customerSpecModalId: state.ui && state.ui.customerSpecModalId,
        form: TYPE_FORM(specType),
        typeValues: getFormValues(TYPE_FORM(specType))(state),
        dynValues: getFormValues(DYNAMIC_FORM(specType))(state),
        dynErrors: getFormSyncErrors(DYNAMIC_FORM(specType))(state),
        specType,
        customerSpecModificationContext: state.ui && state.ui.customerSpecModificationContext,
    };
};

const convertOptions = options => (!options ? [] : options.map(option => ({ label: option.name, value: option.id })));

const Form = props => {
    const {
        t,
        typeValues,
        dynValues,
        dynErrors,
        history,
        closeModal,
        match: {
            params: { id: customerPathId },
        },
        customerSpecModalId,
        specType,
        customerSpecModificationContext,
        change,
    } = props;

    const customerId = customerPathId || customerSpecModalId;
    const [isLoading, setIsLoading] = useState(false);
    const [isDetailLoading, setIsDetailLoading] = useState(false);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [objectInfoModal, setObjectInfoModal] = useState({
        open: false,
        data: null,
        expanded: false,
    });
    const [dynParams, setDynParams] = useState(null);
    const [readyToSubmit, setReadyToSubmit] = useState(false);
    const [customerSelected, setCustomerSelected] = useState(
        customerSpecModificationContext && customerSpecModificationContext?.customer
    );

    const isWithoutDynParams = customerSpecModificationContext; // there are no dynParams with customerSpecModificationContext
    const isChangeTypeEnabled = customerSpecModificationContext
        ? get(customerSpecModificationContext, "action.actionData.isChngSpec", false)
        : true;
    const isChangeCustomerEnabled = customerSpecModificationContext
        ? get(customerSpecModificationContext, "action.actionData.isChngClient", false)
        : true;
    const initTypeValue = get(customerSpecModificationContext, "initTypeValue", null);

    const requestServiceTypes = modifySpec => {
        if (modifySpec) {
            setIsLoading(true);
            baseService
                .get("get_spec_modification_list", {
                    pathParams: {
                        objectType: specType.toLowerCase(),
                        id: parseInt(customerSpecModificationContext?.specId, 10),
                    },
                })
                .then(response => {
                    console.log(`response`, response);
                    const { success, result } = response;
                    if (success && result) {
                        setServiceTypes(convertOptions(result));
                        console.log(`setServiceTypes`, convertOptions(result));
                    }
                    setIsLoading(false);
                })
                .catch(e => setIsLoading(false));
        }
        if (!modifySpec) {
            const params = {
                data: {
                    filter: specType.toUpperCase(),
                    customerId,
                },
            };
            setIsLoading(true);
            baseService
                .get("get_service_catalogue", params)
                .then(response => {
                    const { children, success } = response;
                    if (success && children) {
                        setServiceTypes(children);
                    }
                    setIsLoading(false);
                })
                .catch(e => setIsLoading(false));
        }
    };

    const requestDynParams = ({ id, type }) => {
        setDynParams(null);
        const params = {
            data: {
                ctxObjectType: "customer",
                ctxObjectId: customerId,
                objectType: type,
                objectTypeId: id,
                openMode: "create",
                curStepNum: 1,
            },
        };
        setIsLoading(true);
        baseService
            .get("appeal_form_params", params)
            .then(response => {
                const { result, success } = response;
                if (success && result) {
                    const { blocks } = result;
                    setDynParams(blocks);
                }
                setIsLoading(false);
            })
            .catch(e => setIsLoading(false));
    };

    const requestServiceDetails = ({ type, isFolder, id }) => {
        const params = {
            pathParams: {
                id,
            },
            data: {
                componentCode: "description",
                objectType: type,
                mimeType: "text",
                isFolder,
            },
            jsonType: true,
        };
        setIsDetailLoading(true);
        baseService
            .get("get_service_catalogue_detail", params)
            .then(response => {
                const { result, success } = response;
                if (success && result.content) {
                    setObjectInfoModal(state => ({ ...state, data: result.content }));
                } else {
                    setObjectInfoModal(state => ({ ...state, data: null }));
                    console.log("Object additional info request failed");
                }
                setIsDetailLoading(false);
            })
            .catch(e => setIsDetailLoading(false));
    };

    const requestServiceDetailsModification = id => {
        const params = {
            pathParams: {
                id,
            },
            data: {
                componentCode: "description",
                objectType: specType,
                mimeType: "text",
                // isFolder,
            },
            jsonType: true,
        };
        setIsDetailLoading(true);
        baseService
            .get("get_service_catalogue_detail", params)
            .then(response => {
                const { result, success } = response;
                if (success && result.content) {
                    setObjectInfoModal(state => ({ ...state, data: result.content }));
                } else {
                    setObjectInfoModal(state => ({ ...state, data: null }));
                    console.log("Object additional info request failed");
                }
                setIsDetailLoading(false);
            })
            .catch(e => setIsDetailLoading(false));
    };

    const handleObjectInfo = () => {
        setObjectInfoModal(state => ({ ...state, open: true }));
    };

    const onTypeChange = (event, newValue) => {
        if (!isWithoutDynParams) {
            requestDynParams(newValue);
        }
        requestServiceDetails(newValue);
    };

    const onTypeChangeModification = (event, newValue) => {
        requestServiceDetailsModification(newValue);
    };

    const onSubmit = modifySpec => {
        if (readyToSubmit && !isLoading) {
            if (!modifySpec) {
                let dynParamsValues = [];

                if (dynValues) {
                    dynParamsValues = Object.keys(dynValues).map(key => ({ [key]: dynValues[key] }));
                }

                const params = {
                    data: {
                        customerId,
                        specId: typeValues.type.id,
                        params: dynParamsValues,
                    },
                    jsonType: true,
                };
                setIsLoading(true);
                baseService
                    .post("customer_save_service", params)
                    .then(response => {
                        setIsLoading(false);
                        const { result, success } = response;
                        if (success && result) {
                            const { specInstId } = result;
                            closeModal();
                            history.push(`/${specType}/${specInstId}`);
                        }
                    })
                    .catch(e => setIsLoading(false));
            }
            if (modifySpec) {
                const params = {
                    pathParams: { objectType: specType },
                    data: {
                        id: parseInt(customerSpecModificationContext.specId, 10),
                        actionCode: customerSpecModificationContext.action.actionData.actionCode,
                        specId: parseInt(typeValues.type.id, 10),
                        customerId: customerSelected.id,
                    },
                    jsonType: true,
                };
                setIsLoading(true);
                baseService
                    .post("customer_modify_spec", params)
                    .then(response => {
                        setIsLoading(false);
                        const { result, success } = response;
                        if (success && result) {
                            const { specInstId, objectType } = result;
                            closeModal();
                            history.push(`/${objectType}/${specInstId}`);
                        }
                    })
                    .catch(e => setIsLoading(false));
            }
        }
    };

    useEffect(() => {
        const isSomeDataLoading = isDetailLoading || isLoading;
        if (!isSomeDataLoading && typeValues && isEmpty(dynErrors)) {
            setReadyToSubmit(true);
        } else {
            setReadyToSubmit(false);
        }
    }, [typeValues, dynValues, dynErrors, isDetailLoading, isLoading]);

    useEffect(() => {
        // init spec type value
        if (initTypeValue) {
            change("type", initTypeValue);
        }
        if (isChangeTypeEnabled) {
            requestServiceTypes(!!customerSpecModificationContext);
        }
    }, []);

    return (
        <>
            <div className={cx("customer-spec-form", { "spec-modification": customerSpecModificationContext })}>
                {(isDetailLoading || isLoading) && <Loader />}
                <div className={cx("customer-type-select", { "type-select-disabled": !isChangeTypeEnabled })}>
                    {!customerSpecModificationContext && (
                        <Field
                            name="type"
                            component={TypeSelect}
                            valueKey="id"
                            labelKey="name"
                            title={t(`tabs.${specType}`)}
                            nodeArray={serviceTypes}
                            disabled={!isChangeTypeEnabled}
                            onChange={onTypeChange}
                        />
                    )}
                    {customerSpecModificationContext && (
                        <Field
                            component={ComboBox}
                            name="type"
                            valueKey="id"
                            labelKey="name"
                            placeholder={initTypeValue && initTypeValue.name}
                            title={t(`tabs.${specType}`)}
                            searchable={false}
                            clearable={false}
                            options={serviceTypes}
                            disabled={!isChangeTypeEnabled}
                            onChange={onTypeChangeModification}
                        />
                    )}
                    <button
                        type="button"
                        className={objectInfoModal.data ? "btn-save" : "btn-save disabled"}
                        disabled={!objectInfoModal.data}
                        onClick={handleObjectInfo}
                    >
                        <ReactSVG className="info-icon" src="/data/svg/info.svg" />
                        {/* <i className='icon icon-info-circle' /> */}
                    </button>
                </div>
                {dynParams && (
                    <DynamicForm
                        formName={DYNAMIC_FORM(specType)}
                        dynData={dynParams}
                        confGridObjectType={typeValues && typeValues.type && typeValues.type.type}
                        currentId={typeValues && typeValues.type && typeValues.type.id}
                        t={t}
                        confGridWithoutFieldsCache
                        confGridWithoutSortCache
                    />
                )}
                {customerSpecModificationContext && (
                    <CompactCustomerSearch
                        onCustomerSelected={setCustomerSelected}
                        disabled={!isChangeCustomerEnabled}
                        preselectedCustomer={customerSpecModificationContext.customer}
                    />
                )}
                <div className="customer-service-actions">
                    <button
                        className={readyToSubmit ? "btn btn-primary" : "btn btn-primary disabled"}
                        type="button"
                        onClick={() => onSubmit(!!customerSpecModificationContext)}
                    >
                        {customerSpecModificationContext ? t("next") : t("save")}
                    </button>
                </div>
            </div>
            {objectInfoModal.open && (
                <ModalWindow
                    className={
                        objectInfoModal.expanded
                            ? "ordering-component-ui-core-wrapper html-wrapper expanded"
                            : "ordering-component-ui-core-wrapper html-wrapper"
                    }
                    onClose={() => setObjectInfoModal(state => ({ ...state, open: false }))}
                >
                    <header className="modal-window-header">
                        <div className="modal-window-title">{t("additionalInfo")}</div>
                        <button
                            type="button"
                            className="btn-save expand"
                            onClick={() =>
                                setObjectInfoModal(state => ({
                                    ...state,
                                    expanded: !state.expanded,
                                }))
                            }
                        >
                            {objectInfoModal.expanded ? (
                                <ReactSVG className="expand-icon" src="/data/svg/re-expand.svg" />
                            ) : (
                                <ReactSVG className="expand-icon" src="/data/svg/expand.svg" />
                            )}
                        </button>
                    </header>
                    <div className="object-info-html-wrapper">
                        <div dangerouslySetInnerHTML={{ __html: escapeBaseTag(objectInfoModal.data) }} />
                    </div>
                </ModalWindow>
            )}
        </>
    );
};

export default connect(mapStateToProps, null)(withRouter(reduxForm()(withTranslation()(Form))));
